import React from 'react';

const ItCompaniesPage = () => {
  return (
    <div>
      <h1>IT Companies</h1>
    </div>
  );
};

export default ItCompaniesPage;
